import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TransitionComponent } from "./transition.component";
import { TransitionNumberComponent } from "./transition-number/transition-number.component";
import { TransitionHeightComponent } from "./transition-height/transition-height.component";

@NgModule({
	declarations: [
		TransitionComponent,
		TransitionNumberComponent,
		TransitionHeightComponent
	],
	imports: [CommonModule],
	exports: [
		TransitionComponent,
		TransitionNumberComponent,
		TransitionHeightComponent
	]
})
export class TransitionModule {}
